module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0087.png.b2f66dcb.jpg";